export const styles = {
    formControl: {
        display: "flex",
        flexDirection: "column",
        gap: "2px", // Space between FormLabel and RadioGroup
    },
    formLabel: {
        color: "#8B8E98", // Static color for the label
        fontSize: "10px",
        fontWeight: "500",
        "&.Mui-focused": {
            color: "#8B8E98", // Prevent color change on focus
        },
        "&.Mui-error": {
            color: "#8B8E98", // Prevent color change on error
        }
    },
    radioGroup: {
        display: "flex",
        justifyContent: "flex-start", // Align to the left
        alignItems: "center", // Align vertically
        gap: "16px", // Space between radio buttons
    },
    radio: {
        padding: "2px",
        color: "#8B8E98", // Default color
        "&.Mui-checked": {
            color: "var(--primaryHeading)", // Custom selected color
        },
        "&:hover": {
            color: "var(--primaryHeading)", // Custom hover color
            backgroundColor: "transparent",
        },
    },
    formControlLabel: {
        marginLeft: 0, // Prevent extra indentation
        gap: "8px"
    },
};
